<template>
  <Modal ref="modal" class="modal-inquiry-convert" :actions="actions" @action="handleAction" immediate :user-closable="false">
    <h1>Fall konvertieren</h1>
    <p>Sie versuchen den Fall mit der SAV-ID <strong>{{ inquiryid }}</strong> zu öffnen. Dieser wurde mit einer<br/> alten Version des SAV-Tools erstellt. Sie können den Fall entweder konvertieren<br/> oder im Lese-Modus öffnen.</p>
    <p class="flexed">
      <span>ℹ️</span>
      <strong>Bei der Konvertierung kann nicht sichergestellt werden, dass alle alten Felder<br/> übernommen werden. Wir empfehlen den Fall im Lese-Modus zu öffnen und als<br/> PDF oder Word herunterzuladen.
      </strong>
    </p>
  </Modal>
</template>

<script>
  import Modal from '@/components/ui/Modal';

  export default {
    name: 'ModalInquiryConvert',
    components: {
      Modal,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      inquiryid: {
        type: String,
        default: null,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      actions() {
        const i18n = this.$i18n;
        return [
          { value: 'readonly', label: i18n.t('labels.openReadOnly') },
          { value: 'convert', label: i18n.t('labels.convert') },
        ];
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // async created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      async handleAction(action) {
        this.$emit(action);
        this.$refs.modal.close();
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.modal-inquiry-convert {
  h1 {
    margin-bottom: 12px;
  }

  p {
    @include font-body-medium;
    color: $color-black-solid-100;
  }

  p.flexed {
    display: flex;
    align-items: center;
    gap: 16px;

    & > span {
      font-size: 2.4rem;
    }
    & > strong {
      font-size: 1.2rem;
      text-transform: uppercase;
    }
  }

  form {
    padding: 24px 0;

    .group {
      margin-bottom: 24px;
      &:last-of-type {
        margin-bottom: 0;
      }
    }

    hr {
      border: 0;
      margin: 24px 0;
      border-bottom: 1px solid $color-black-alpha-10;
    }
  }
}
</style>
